//Tema 4
import neto from "./Neto.png"
import netoChat1 from "./Neto_chat1.png"
import netoChat2 from "./Neto_chat2.png"
import netoWithEllipsisChat from "./netoWithEllipsisDialogue.png"
import netoWithChips from "./netoWithChips.png"
import infoSub2Act1 from "./infoSub2Act1.png"
import infoSub2Act2 from "./infoSub2Act2.png"
import loginSub3Act2 from "./loginSub3Act2.png"
import monitorImg1Sub4Act2 from "./monitorImage1Sub4Act2.png";
import monitorImg2Sub4Act2 from "./monitorImage2Sub4Act2.png";
import yolanda from './yolanda.png'
import yolandaWithCoke from './yolandaWithCoke.png'
import yolandaWithMoney from './yolandaWithMoney.png'
import textureBillets_20 from './TXT_Billetes_20_AL.png'
import textureBillets_50 from './TXT_Billetes_50_AL.png'
import textureBillets_100 from './TXT_Billetes_100_AL.png'
import textureBillets_200 from './TXT_Billetes_200_AL.png'
import textureBillets_500 from './TXT_Billetes_500_AL.png'
import amanda from './Amanda.png'
import amandaWithCoke from './AmandaWithCoke.png'
import monitorImg3Sub4Act4 from "./monitorImage3Sub4Act4.png";
import amandaWithHotDog from './amandaWithHotDog.png'
import monitorImg4Sub4Act5 from "./monitorImage4Sub4Act5.png";
import netoWithCoke from "./netoWithCoke.png";
import amandaWithCard from "./amandaWithCard.png";
import netoWithTicket from "./netoWithTicket.png";
import yolandaWithCoupon from "./yolandaWithCoupon.png";
import netoResting from "./netoResting.png";
import monitorImg5Sub5Act2 from "./monitorImage5Sub5Act2.png";
import manCardOne from "./manCardOne.png";
import manCardTwo from "./manCardTwo.png";
import manCardThree from "./manCardThree.png";
import ChicoMalo1 from "./ChicoMalo1.png";
import ChicoMalo2 from "./ChicoMalo2.png";


export const imgsTopic4 = {
	neto,
	netoChat1,
	netoChat2,
	netoWithEllipsisChat,
	netoWithChips,
	infoSub2Act1,
	infoSub2Act2,
	loginSub3Act2,
	monitorImg1Sub4Act2,
	monitorImg2Sub4Act2,
	yolanda,
	yolandaWithCoke,
	yolandaWithMoney,
	textureBillets_20,
	textureBillets_50,
	textureBillets_100,
	textureBillets_200,
	textureBillets_500,
	amanda,
	amandaWithCoke,
	monitorImg3Sub4Act4,
	amandaWithHotDog,
	monitorImg4Sub4Act5,
	netoWithCoke,
	amandaWithCard,
	netoWithTicket,
	yolandaWithCoupon,
	netoResting,
	monitorImg5Sub5Act2,
	manCardOne,
	manCardTwo,
	manCardThree,
	ChicoMalo1,
	ChicoMalo2,
}